export const ACCOUNTING_PERMISSIONS = {
  pnl: {
    read: 'accounting.pnl.read',
    refresh: 'accounting.pnl.refresh',
  },
  invoices: {
    read: 'accounting.invoices.read',
    create: 'accounting.invoices.create',
    modify: 'accounting.invoices.modify',
    void: 'accounting.invoices.void',
    payment: 'accounting.invoices.payment',
    attachDocument: 'accounting.invoices.attach_document',
  },
  reconciliations: {
    read: 'accounting.reconciliations.read',
    create: 'accounting.reconciliations.create',
    modify: 'accounting.reconciliations.modify',
    aiExtract: 'accounting.reconciliations.ai_extract',
    start: 'accounting.reconciliations.start',
  },
  receivable: {
    read: 'accounting.receivable.read',
  },
  payable: {
    read: 'accounting.payable.read',
  },
  bills: {
    read: 'accounting.bills.read',
    modify: 'accounting.bills.modify',
  },
  suppliers: {
    read: 'accounting.suppliers.read',
    create: 'accounting.suppliers.create',
    modify: 'accounting.suppliers.modify',
    delete: 'accounting.suppliers.delete',
  },
} as const;
